import React from "react";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট
import { config } from "../../../config";

const imageUrl = config.imageUrl;

const UpdateBlog = ({ formData,editingBlog,closeModal, handleChange,handleQuillChange,handleFileChange, handleSubmit, error,authors,categories }) => {



  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Blog</h2>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Blog Title */}
        <div className="mb-4">
          <label className="block text-gray-700">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Blog Slug */}
        <div className="mb-4">
          <label className="block text-gray-700">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Content */}
        <div className="mb-4">
          <label className="block text-gray-700">Content</label>
          <ReactQuill
            key={formData.slug || editingBlog}
             theme="snow"
            value={formData.content || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            className="border w-full p-2"
            style={{ 
              height: '400px', // Default height
              minHeight: '300px', // Minimum height
              maxHeight: '600px', // Maximum height
              resize: 'vertical', // Allow client to resize the section vertically
              overflow: 'auto' // Add scroll if content exceeds height
            }}
          />
        </div>

        {/* Blog Image */}
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <img src={`${imageUrl}/${formData.image}`} alt="Blog" className="h-48 w-full object-cover mb-4" />
          <label className="block text-gray-700">Image URL</label>
          <input
            type="file"
            name="image"
            onChange={handleFileChange}
            className="border w-full p-2"
          />
        </div>

        {/* Featured Checkbox */}
        <div className="mb-4">
          <label className="block text-gray-700">Is Featured</label>
          <input
            type="checkbox"
            name="is_featured"
            checked={formData.is_featured}
            onChange={handleChange}
            className="mr-2"
          />
        </div>

         {/* Author */}
         <div className="mb-4">
          <label className="block text-gray-700">Author</label>
          <select
            name="author_id"
            value={formData.author_id}
            onChange={handleChange}
            className="border w-full p-2"
            required
          >
            <option value="">Select Author</option>
            {authors.map((author) => (
              <option key={author.id} value={author.id}>
                {author.name}
              </option>
            ))}
          </select>
        </div>

        {/* Category */}
        <div className="mb-4">
          <label className="block text-gray-700">Category</label>
          <select
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
            className="border w-full p-2"
            required
          >
            <option value="">Select Category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={closeModal}
            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateBlog;
